import { AdjustmentReasonsService } from '@/backend/market'
import { AdjustmentReasonMiniModel } from '../models/AdjustmentReasonMiniModel'
import { CreateUpdateAdjustmentReasonModel } from '../models/CreateUpdateAdjustmentReasonModel'
import type { AdjustmentReasonEntity } from '../../domain/entities/AdjustmentReasonEntity'
import type { AdjustmentReasonMiniEntity } from '../../domain/entities/AdjustmentReasonMiniEntity'
import type { AdjustmentReasonRepository } from '../../domain/repositories/AdjustmentReasonRepository'

export class AdjustmentReasonRepositoryImpl implements AdjustmentReasonRepository {
  async getAdjustmentReasons(): Promise<AdjustmentReasonMiniEntity[] | { error: true }> {
    try {
      const response = await AdjustmentReasonsService.getAdjustmentReasonsAdmin()
      return response.map((reason) => new AdjustmentReasonMiniModel(reason))
    } catch {
      return { error: true }
    }
  }

  async createAdjustmentReason(
    data: AdjustmentReasonEntity
  ): Promise<{ success: true } | { error: true }> {
    try {
      const createUpdateAdjustmentReasonModel = new CreateUpdateAdjustmentReasonModel(data)
      await AdjustmentReasonsService.createAdjustmentReasonAdmin({
        requestBody: createUpdateAdjustmentReasonModel
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }

  async updateAdjustmentReason(
    id: number,
    data: AdjustmentReasonEntity
  ): Promise<{ success: true } | { error: true }> {
    try {
      const createUpdateAdjustmentReasonModel = new CreateUpdateAdjustmentReasonModel(data)
      await AdjustmentReasonsService.updateAdjustmentReasonAdmin({
        id,
        requestBody: createUpdateAdjustmentReasonModel
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }

  async deleteAdjustmentReason(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await AdjustmentReasonsService.deleteAdjustmentReasonAdmin({
        id
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
